<template>
  <v-card class="asset-reconcile">
    <v-card-title>Purchase Reconciliation</v-card-title>

    <v-card-text>
      <v-alert
        type="error"
        v-if="errorMsg"
      >
        {{ errorMsg }}
      </v-alert>

      <v-form
        ref="form"
        v-model="valid"
        lazy-validation
      >

      <!-- Purchase Price -->
      <v-text-field
        v-model.number="purchasePayload.totalPurchasePrice"
        label="Sale Price"
        prefix="$"
        :rules="reqRules"
        @change="isProfitable"
      ></v-text-field>

      <v-row>
        <v-col md="4">
          <v-text-field
            v-model.number="purchasePayload.consignorProfitPercentage"
            label="Consignor Percentage"
            suffix="%"
            :rules="reqRules"
          ></v-text-field>
        </v-col>
        <v-col md="4">
          <v-text-field
            v-model.number="purchasePayload.shareholderProfitPercentage"
            label="Share Holder Percentage"
            suffix="%"
            :rules="reqRules"
          ></v-text-field>
        </v-col>
        <v-col md="4">
          <v-text-field
            v-model.number="purchasePayload.bccProfitPercentage"
            label="BCC Percentage"
            suffix="%"
            :rules="reqRules"
          ></v-text-field>
        </v-col>
      </v-row>

      <!-- Purchaser User -->
      <v-autocomplete
        v-model="purchasePayload.userId"
        :loading="searchLoading"
        :items="adminUserSearchResults"
        item-text="emailAddress"
        item-value="id"
        :search-input.sync="search"
        :rules="[v => !!v || 'Purchaser is required.']"
        cache-items
        prepend-icon="mdi-account-search"
        flat
        label="Purchaser"
      ></v-autocomplete>


      </v-form>
    </v-card-text>

    <v-card-actions
      class="mt-3"
    >
      <v-btn
        color="primary"
        :loading="loading"
        :disabled="loading"
        @click="reconcile"
      >
        <v-icon left>
          mdi-cash-check
        </v-icon>
        Reconcile Purchse
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'

  export default {
    name: 'PurchaseForm',

    components: {
    },

    computed: {
      ...mapGetters([
        'adminAsset',
        'adminUserSearchResults'
      ]),
    },

    data: () => ({
      // User Search
      searchLoading: false,
      search: null,

      // Form handling.
      loading: false,
      valid: true,
      errorMsg: '',
      reqRules: [
        value => (!!value || Number(value) === 0) && Number.isInteger(Number(value)) || 'Must be a whole number.'
      ],

      // Purchase payload.
      purchasePayload: {
        totalPurchasePrice: null,
        userId: null,
        consignorProfitPercentage: 45,
        shareholderProfitPercentage: 45,
        bccProfitPercentage: 10
      },
    }),

    methods: {
      ...mapActions([
        'purchase',
        'userSearch'
      ]),

      isProfitable () {
        const breakeven = this.adminAsset.pricePerShare * this.adminAsset.totalShares
        if (this.purchasePayload.totalPurchasePrice >= breakeven) {
          this.purchasePayload.consignorProfitPercentage = 45
          this.purchasePayload.shareholderProfitPercentage = 45
          this.purchasePayload.bccProfitPercentage = 10
        }
        else {
          this.purchasePayload.consignorProfitPercentage = 50
          this.purchasePayload.shareholderProfitPercentage = 50
          this.purchasePayload.bccProfitPercentage = 0
        }
      },

      checkPercent () {
        if (this.purchasePayload.consignorProfitPercentage + this.purchasePayload.shareholderProfitPercentage + this.purchasePayload.bccProfitPercentage === 100) {
          return true
        }
        return false
      },

      // Querying on the users.
      searchUsers (q) {
        this.searchLoading = true

        this.userSearch(q).then(() => {
          this.searchLoading = false
        }).catch(() => {
          this.searchLoading = false
        })
      },

      // Reconcile asset purchase.
      reconcile: function () {
        this.loading = true
        // Validate the form
        this.valid = this.$refs.form.validate()
        console.log(this.valid)

        this.valid = this.checkPercent()
        console.log(this.valid)

        if (this.valid === true) {
          // Try to log the purchase.
          this.purchase({
            assetId: this.adminAsset.id,
            purchasePayload: this.purchasePayload
          })
          .then(() => {
            this.$emit('dialogClose')
          })
          .finally(() => {
            this.loading = false
          })
        }
        else {
          this.loading = false
        }
      }
    },

    watch: {
      search (val) {
        val && this.searchUsers(val)
      }
    },
  }
</script>
